import PATH from "constants/path";
import React from "react";
import { ButtonBanner, ChevronRight } from "assets/svg";
import { isAuthenticated } from "utils/common";
import {
  illust02,
  illust05,
  illust06,
  illust07,
  illust09,
  illust11,
} from "assets/img";

function Guide() {
  return (
    <div className={isAuthenticated() ? "w-80" : "itsumoni container px-0"}>
      <div className="bg-green text-white py-2 text-center position-relative sp-1 fw-600 z-index-2">
        <div className="fs-12 lh-21">＼とってもカンタン!／</div>
        <div className="fs-20 fs-sm-18">ご利用方法</div>
        <img
          className="position-absolute top-100 top-sm-75 end-0 translate-middle-y img-w mb-sm-0"
          src={illust02}
          alt={illust02}
        ></img>
      </div>
      {!isAuthenticated() ? (
        <div className="px-3 px-md-5 py-3 text-lg-center bg-brown z-index-1">
          <div className="fs-14 fs-sm-13 fw-600 sp-14 text-center text-grey">
            まずは、カンタン無料会員登録!
          </div>
          <div className="text-center mt-1">
            <a href={PATH.COMMON + PATH.SIGNUP}>
              <ButtonBanner className="svg-button" />
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className={`z-index-1 ${isAuthenticated() ? "mt-4" : "my-2"} `}>
        {!isAuthenticated() && (
          <div className="fs-14 fw-600 sp-14 text-center text-grey-2 mb-2 mb-md-4">
            以下、ご登録後の流れになります。
          </div>
        )}
        <div className="list-guide mx-0 mx-md-4 mx-lg-0">
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>1</span>
                <div>新しい案件に応募</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0 px-md-auto">
                  <img
                    src={illust06}
                    alt="illust06"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-1 px-md-auto mt-2">
                  ご応募いただけるモニター案件は、ログイン後にある「
                  <span className="fw-600 text-red-light">
                    モニター募集一覧
                  </span>
                  」に掲載されております。
                  <br />
                  またはご登録いただいているメールアドレス宛にアンケートのご案内が届くので、指定ドメインの迷惑メールの解除をお願いします。参加条件をご確認いただき、モニター案件の説明にしたがってご応募ください。ログインしていない状態ではモニター案件の詳細が表示されないのでご注意ください。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>2</span>
                <div>
                  <div>「応募中案件」で案件の進行状況を確認</div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0 px-md-auto">
                  <img
                    src={illust05}
                    alt="illust05"
                    className="list-guide-img"
                  />
                </div>
                {isAuthenticated() ? (
                  <div className="col-8 col-md-12 px-1 px-md-auto mt-2 sp-14">
                    応募したすべてのモニター案件はマイページにある「
                    <span className="fw-600 text-red-light">応募中案件</span>
                    」に表示されます。「
                    <span className="fw-600 text-red-light">ステップ詳細</span>
                    」をクリックすると、現在の進行状況をご確認できます。
                  </div>
                ) : (
                  <div className="col-8 col-md-12 px-1 px-md-auto mt-2 sp-14">
                    応募したすべてのモニター案件は「
                    <span className="fw-600 text-red-light">応募中案件</span>
                    」に表示されます。「
                    <span className="fw-600 text-red-light">ステップ詳細</span>
                    」をクリックすると、現在の進行状況をご確認できます。
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>3</span>
                <div>モニター調査に参加</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0 px-md-auto">
                  <img
                    src={illust09}
                    alt="illust09"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-1 px-md-auto mt-2">
                  モニター案件にご参加される場合は必ず、自らがモニターであることを一切明かさず、一般のご利用者として最後までご参加ください。
                  <br />
                  例えば、エステサロンの体験モニター調査にご参加される際は、モニター案件の詳細や進め方に沿って一般のご利用者として予約を取ってください。予約が完了しましたら、店舗名と訪問日時をご報告いただき、施術日も自らがモニターではなく一般のご利用者として施術を体験してください。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <div className="title">
                <span>4</span>
                <div>アンケートに回答</div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0 px-md-auto">
                  <img
                    src={illust11}
                    alt="illust11"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-1 px-md-auto mt-2">
                  モニター案件が完了しましたら、簡単なアンケートにご回答ください。アンケートにご協力いただけない場合、あるいは回答内容に不足や不正があった場合、謝礼のポイントを付与することはできません。
                </div>
              </div>
            </div>
          </div>
          <div className="card border-color-grey-2 border-color-sm-none position-relative p-3 pt-3">
            <div className="card-title">
              <h5 className="title">
                <span>5</span>
                <div>謝礼を受け取る</div>
              </h5>
            </div>

            <div className="card-body p-0">
              <div className="row">
                <div className="col-4 col-md-12 px-0 px-md-auto">
                  <img
                    src={illust07}
                    alt="illust07"
                    className="list-guide-img"
                  />
                </div>
                <div className="col-8 col-md-12 px-1 px-md-auto mt-2">
                  アンケートの回答が完了し、内容に問題がないこと確認できましたら、謝礼のポイントが付与されます。
                  <br />
                  <span className="fw-600 text-red-light">
                    1,000ポイント以上
                  </span>
                  貯めると、お振込みの対象となります。アンケートの回答からポイント付与まで
                  <span className="fw-600 text-red-light">最大2か月</span>
                  かかることもありますのであらかじめご了承ください。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fw-400 fs-14 sp-14 my-3 my-md-4">
        <div className="bg-green-light-2 py-1">
          <div className="text-white fs-18 fw-600 text-center">注意事項</div>
        </div>
        <div className="px-4 px-lg-0 fs-14 fs-sm-13 word-break-normal">
          <div className="my-4">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              モニター案件の参加条件は必ずお守りください。
            </div>
            <div>
              いつモニで掲載しているモニター案件には、「○○というお店に行ったことがない方」や「○○の商品を初めて購入する(使用する)方」など、いくつか参加条件を設けている場合があります。参加条件に当てはまらない案件にご応募いただいたり、参加条件を偽ってご応募いただいた場合には、謝礼ポイントの付与はされません。悪質な場合は、退会処分となります。
            </div>
          </div>
          <div className="my-4">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              機密保持にご協力ください。
            </div>
            <div>
              いつモニで掲載しているモニター案件の内容や詳細をSNS、YouTube、ブログ、ネット掲示板などに転載、転記することは固く禁じております。また、「いつモニの覆面調査員として活動します(しました)」という自らがモニターであることを明かすことを公表することも同様に禁じております。
            </div>
          </div>
          <div className="my-4">
            <div className="text-red-light my-1 fw-600 sp-14 sp-sm-0">
              <span className="me-1">
                <i className="bi bi-exclamation-triangle-fill"> </i>
              </span>
              お振込をお断りするケース
            </div>
            <div>
              いつモニでは、以下の事由に当てはまる場合は、モニター案件の体験後、アンケート完了後であってもポイントの付与をお断りすることがあります。
              <br />
              <br />
              ・氏名、年齢、性別など個人情報を偽って登録した場合
              <br />
              ・参加条件を偽ってご応募した場合
              <br />
              ・モニター案件の掲載期限を超えて完了した場合
              <br />
              ・機密保持などの注意事項を破った場合
            </div>
          </div>
          <div className="my-4">
            <span className="me-1 text-red-light">
              <i className="bi bi-exclamation-triangle-fill"> </i>
            </span>
            上記注意事項を破られた場合は、ポイントの付与がされないだけでなく、損害賠償請求をさせていただきますのでくれぐれもご注意ください。
          </div>
        </div>
      </div>

      <div className="text-grey fs-14 fs-sm-12 fw-600 mt-5">
        <div className="w-130 mx-auto text-end mt-3 mt-md-2">
          <a href={PATH.FIRST}>
            はじめての方へ
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="w-130 mx-auto text-end mt-3 mt-md-2">
          <a href={PATH.POINT}>
            ポイントについて
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="w-130 mx-auto text-end mt-3 mt-md-2">
          <a href={PATH.QUESTIONS}>
            よくあるご質問
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Guide;
